import { TextContentElement } from '@deltek/specification-client/core/Models/textContentElement'
import React, { useCallback } from 'react'
import { countSpecialChars } from '../../components/ContentEditor/contentUtils'
import {
    cancellingPills,
    resizeInput,
    UOM_MAX_LENGTH,
    UOM_MAX_SPECIAL_CHARS,
} from './uomPillState'

export interface UOMPillInputProps {
    localValue: string
    className: string
    parentContentItemId?: string
    onCancel?: () => void
    unitType: 'imperial' | 'metric'
    onValueChange: (updatedItem: Partial<TextContentElement>, unitType: 'imperial' | 'metric') => void
}

export const UOMPillInput = ({
    localValue,
    className,
    parentContentItemId,
    onCancel,
    unitType,
    onValueChange,
}: UOMPillInputProps) => {
    const inputRef = useCallback((node: HTMLInputElement | null) => {
        if (node) resizeInput(node, 3)
    }, [])

    return (
        <input
            type="text"
            defaultValue={localValue}
            maxLength={UOM_MAX_LENGTH}
            className={className}
            data-uom-pill-input
            ref={inputRef}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => {
                if (e.key === 'Escape') {
                    e.stopPropagation()
                    if (parentContentItemId) cancellingPills.add(parentContentItemId)
                    onCancel?.()
                }
            }}
            onChange={(e) => {
                const val = e.target.value
                if (countSpecialChars(val) > UOM_MAX_SPECIAL_CHARS) return
                resizeInput(e.target, 3)
                onValueChange({ text: val }, unitType)
            }}
        />
    )
}
